import { notification } from 'antd'
import { getIdOrNull, requestImage, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const getAllUsers = (user, parameters) => apiClient.get(user, 'api/users', parameters)

export const createUser = (body, user) => apiClient.post(user, 'user/create', body)

export const deleteUser = (userId, user, callback) => {
  requestWithPromise(`/api/User/${userId}`, HttpMethods.DELETE, null, user)
    .then(json => {
      if (json && json.data) {
        callback(json.data)
      } else {
        console.error(json)
        notification.error({
          message: 'The users cannot be deleted correctly',
          placement: 'bottomRight'
        })
      }
    })
}

export const updateUser = (userData, user, callback, errorCallback = undefined) => {
  requestWithPromise(`/user/modify/${userData.id}`, HttpMethods.POST, userData, user)
    .then(json => {
      if (json && json.data) {
        callback(json.data)
      } else {
        console.error(json)
        notification.error({
          message: 'The users cannot be updated correctly',
          placement: 'bottomRight'
        })

        if (errorCallback) {
          errorCallback()
        }
      }
    })
}

export const getUserSpecialities = (user, selectedUser) => apiClient.get(user, `api/users/${getIdOrNull(selectedUser)}/school-specialities`)
export const getUserSpecialyYears = (user, selectedUser) => apiClient.get(user, `api/users/${getIdOrNull(selectedUser)}/speciality-years`)
export const getUserContactSpecialyYears = (user, selectedUser) => apiClient.get(user, `api/users/${getIdOrNull(selectedUser)}/contact-speciality-years`)

export const linkUserToSpeciality = (user, selectedUser, speciality) =>
  apiClient.post(user, `api/users/${getIdOrNull(selectedUser)}/school-specialities`, { schoolSpeciality: speciality.id })

export const unlinkUserToSpeciality = (user, selectedUser, speciality) =>
  apiClient.delete(user, `api/users/${getIdOrNull(selectedUser)}/school-specialities/${speciality.id}`)

export const linkUserToSpecialityYears = (user, selectedUser, specialityYearIds) =>
  apiClient.post(user, `api/users/${getIdOrNull(selectedUser)}/speciality-years`, { ids: specialityYearIds })

export const unlinkUserToSpecialityYears = (user, selectedUser, specialityYearIds) =>
  apiClient.delete(user, `api/users/${getIdOrNull(selectedUser)}/speciality-years`, { ids: specialityYearIds })

export const linkUserToContactSpecialityYears = (user, selectedUser, specialityYearIds) =>
  apiClient.post(user, `api/users/${getIdOrNull(selectedUser)}/contact-speciality-years`, { ids: specialityYearIds })

export const unlinkUserToContactSpecialityYears = (user, selectedUser, specialityYearIds) =>
  apiClient.delete(user, `api/users/${getIdOrNull(selectedUser)}/contact-speciality-years`, { ids: specialityYearIds })

export const getContactPersonSpecialitiesBySchool = (selectedUser, school, user) => {
  return requestWithPromise(
    `/api/users/${selectedUser.id}/contact-person-school-specialities?school=${school}`,
    HttpMethods.GET,
    null,
    user
  ).then(json => {
    if (json && json.data) {
      return json.data
    }
  })
}

export const getContactPersonSpecialitiesByInstitution = (selectedUser, institution, user) => {
  return requestWithPromise(
    `/api/users/${selectedUser.id}/contact-person-speciality-years?institution=${institution}`,
    HttpMethods.GET,
    null,
    user
  ).then(json => {
    if (json && json.data) {
      return json.data
    }
  })
}

export const getProfileImage = (user) => {
  return requestImage(
    `/api/users/${user.id}/profile-image`,
    HttpMethods.GET,
    null,
    user
  ).then(img => {
    if (img) {
      return img
    }
  })
}

export const changePassword = (user, password, passwordConfirm, shouldModifyPassword = false) => {
  return requestWithPromise(
    '/user/reset-password',
    HttpMethods.POST,
    {
      password,
      passwordConfirm,
      shouldModifyPassword,
      userId: user.id
    },
    user
  ).then(json => {
    if (json?.data) {
      return json.data
    }
  })
}
